<template>
    <div class="bottom-head">
        <div class="bottom-head-btn"
             :class="{'select': index === selectEd}"
             @click="setBottomHeaderTab(index)"
             v-for="(btn, index) in bhBtn" :key="btn">{{btn}}
        </div>
        <div class="bot-head-rgt">
            <div class="bot-box1">
                <img src="~@/assets/images/zichan@3x.png"/>总资产:{{account_info?account_info.all_money:'-'}}
            </div>
            <div class="bot-box1">
                <img src="~@/assets/images/money@3x.png"/>可用资金:{{account_info?account_info.can_money:'-'}}
            </div>
            <div class="bot-img" @click="hideFooter" id="bot-img"><img src="~@/assets/images/zuixiaohua.png"/></div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "BaseFooterHeader",
        data() {
            return {
                bhBtn: ['买入', '卖出', '撤单', '查询'],
                selectEd: 0
            }
        },
        computed: {
            account_info: function () {
                if(this.$store.state.account_info) {
                    return this.$store.state.account_info
                }
                return null;
            }
        },
        methods: {
            setBottomHeaderTab(index) {
                if (this.selectEd !== index) {
                    this.selectEd = index;
                    this.$emit('bottomTabChange', index);
                }
            },
            hideFooter() {
                this.$emit('hideFooter', true);
            }
        }
    }
</script>

<style scoped lang="scss">
    .bottom-head-btn {
        cursor: pointer;
    }
</style>
